import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
  auth: {
    tenant: process.env.REACT_APP_TENANT,
    clientId: process.env.REACT_APP_CLIENTID,
    authority: "https://login.microsoftonline.com/" + process.env.REACT_APP_TENANT,
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
    postLogoutRedirectUri: process.env.REACT_APP_POSTLOGOUTURI,
  },
  cache: {
    cacheLocation: "localStorage", // or "sessionStorage"
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);


(async () => {
  await msalInstance.initialize();
})();





// export const msalApiFetch = async (url, options = {}) => {
//   await msalInstance.initialize();
  
//   const accounts = msalInstance.getAllAccounts();

//   if (accounts.length === 0) {
    
//     msalInstance.loginRedirect({
//         scopes: ["user.read"], // replace with your actual scopes
//       });

//   }

//   const request = {
//     account: accounts[0],
//     scopes: [`api://${process.env.REACT_APP_CLIENTID}/user.read`],
//   };

//   try {
//     //await msalInstance.initialize();

//     const response = await msalInstance.acquireTokenSilent(request);
//     const token = response.accessToken;

//     const headers = {
//       ...options.headers,
//       Authorization: `Bearer ${token}`,
//     };

//     return fetch(url, {
//       ...options,
//       headers,
//     });
//   } catch (error) {
//     console.error("Token acquisition failed:", error);
//     throw error;
//   }
// };
 



export const withMsalLoginApi = async (apiCall) => {

  // const accounts = msalInstance.getAllAccounts();

  // if (accounts.length === 0) {
    
  //   msalInstance.loginRedirect({
  //       scopes: ["user.read"], // replace with your actual scopes
  //     });

  // }

  const request = {
    account: null,
    scopes: [`api://${process.env.REACT_APP_CLIENTID}/user.read`],
  };

  try {
    await msalInstance.initialize();

    const response = await msalInstance.acquireTokenSilent(request);
    const token = response.accessToken;

    return await apiCall(token);
  } catch (error) {
    console.error("Token acquisition failed:", error);
  }
};



export const getToken = async () => {

  const accounts = msalInstance.getAllAccounts();

  if (accounts.length === 0) {
    return null;
  }

  const request = {
    account: accounts[0],
    scopes: ["user.read"],
  };

  try {

    const response = await msalInstance.acquireTokenSilent(request);
    return response.accessToken;
  } catch (error) {
    console.error("Silent token acquisition failed:", error);
    return null;
  }
};




export const clearCache = () => {
  const accounts = msalInstance.getAllAccounts();

  accounts.forEach(account => {
    msalInstance.logoutRedirect({
      account,
      postLogoutRedirectUri: "/",
    });
  });

};



export const getCachedUser = () => {
  const accounts = msalInstance.getAllAccounts();

  if (accounts.length === 0) {
    return null;
  }

  return accounts[0];
};







